'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Box, Stack } from '@mui/material';
import styles from './app-footer.module.scss.js';
import { AppFooterTexts } from './app-footer-components/app-footer-texts.component.js';

const AppFooter = ({ imageComponent: ImageComponent = 'img', logo = undefined, testId = undefined, texts = [], }) => (jsx(Box, { className: styles.AppFooter, "data-testid": testId, children: jsxs(Stack, { maxWidth: "xl", className: styles.container, children: [logo ? (jsx(ImageComponent, Object.assign({ className: styles.footerLogo, "data-testid": testId && `${testId}-footerLogo` }, logo))) : null, (texts === null || texts === void 0 ? void 0 : texts.length) ? (jsx(AppFooterTexts, { texts: texts, testId: testId && `${testId}-texts` })) : null] }) }));

export { AppFooter };
